import { createSlice, createSelector } from '@reduxjs/toolkit';
import {SIGNIN, VERIFIED, WAITOTP} from "../../Components/constants/actions";

// import {INIT} from './../constants/status';

const initialState = {
  status: SIGNIN,
  sidebarShow: 'responsive',
  statusShow:'hidden',
  token: '',
  user: {},
  loading: false
};

const baseSlice = createSlice({
  name: 'base',
  initialState,
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setSideBarShow: (state, action) => {
      state.sidebarShow = action.payload;
    },
    setUser: (state, action) => {
      let data = JSON.stringify(action.payload)
      localStorage.setItem(btoa('user'),btoa(unescape(encodeURIComponent(data))));
      state.user = action.payload;
    },
    setToken: (state, action) => {
      const {token} = action.payload;
      state.token = token;
      state.status = 'verified';
      state.statusShow = 'show';
      localStorage.setItem('token',JSON.stringify(token));
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setStatusShow: (state, action) => {
      state.statusShow = action.payload
    }
  },
});

export const { actions } = baseSlice;
export const { setStatus, setSideBarShow, setToken, setUser, setLoading, setStatusShow } = actions;

// selectors
export const selBaseStatus = (state) => state.base.status;
export const selBaseStatusShow = (state) => state.base.statusShow;
export const selSlideShow = (state) => state.base.sidebarShow;
export const selUser = (state) => state.base.user;
export const selToken = (state) => state.base.token;
export const selLoading = (state) => state.base.loading;

const reducer = {
  base: baseSlice.reducer,
};
export default reducer;
